import React from 'react';
import ReactCSSTransitionReplace from 'react-css-transition-replace';
import Display from '../parts/display';

class PortfolioTile extends React.Component {
    constructor() {
        super();
        this.state = {
        };
    }
    render() {
        return (
            <div ref="img" name={this.props.index} className={this.props.right? "portfolio-square col-sm-3 col-xs-6 grey-block content-square pull-right": "portfolio-square col-sm-3 col-xs-6 grey-block content-square"} data-aos="fade">
                <div className="content">
                    <div onClick={this.props.open} data-slug={this.props.slug} name={'square' + this.props.slug}>
                        <ReactCSSTransitionReplace transitionName="cross-fade"
                                                   transitionEnterTimeout={300} transitionLeaveTimeout={300}>
                        <img key={this.props.image} src={this.props.image} className="thumbnail"  />
                            </ReactCSSTransitionReplace>
                        <div className="title" dangerouslySetInnerHTML={{__html: this.props.client.title}}></div>
                        <div className="overlay">
                            <Display if={this.props.client.branding_light}><img src={this.props.client.branding_light} className="client-brand"/></Display>
                            <div>
                                <p className="project-name" dangerouslySetInnerHTML={{__html:this.props.title}}></p>
                                <p className="excerpt">{this.props.excerpt}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default PortfolioTile;


/** WEBPACK FOOTER **
 ** ./src/js/components/portfolio/profileTile.js
 **/